import * as user from 'js/lib/user';

import useSubfolderLanguageAndLocale from 'bundles/internationalization-lib/hooks/useSubfolderLanguageAndLocale';

const useEnableSubfolderLinksForXDP = () => {
  const isOnSubfolderRoute = !!useSubfolderLanguageAndLocale();
  return !user.isAuthenticatedUser() && isOnSubfolderRoute;
};

export default useEnableSubfolderLinksForXDP;
